import { SVGProps } from 'react';

const Projector = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M5 7 3 5m6 1V3m4 4 2-2m-3.17 7H20a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h2.17M16 16h2m-6-3a3 3 0 1 1-6 0 3 3 0 0 1 6 0"
    />
  </svg>
);
export default Projector;
